import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
registerLocaleData(localeEs, 'es-ES');
registerLocaleData(localeEn, 'en-US');

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('app-bootstrapped'));
      try {
        localStorage.removeItem('pwa-update-pending');
      } catch (err) {
        console.warn('Failed to clear update flag:', err);
      }
    }
  })
  .catch((err) => console.error(err));
